var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "ceoHeader" },
      [
        _c(
          "div",
          { staticClass: "mainHeader d-flex justify-content-center" },
          [
            _c(
              "b-navbar",
              {
                staticClass: "mainNav customNav orange",
                attrs: { toggleable: "lg" },
              },
              [
                _c("b-navbar-brand", [
                  _c(
                    "div",
                    {
                      staticClass: "divLogo d-flex",
                      on: {
                        click: function ($event) {
                          return _vm.hideSearchResults()
                        },
                      },
                    },
                    [
                      _c("router-link", { attrs: { to: "/b2b" } }, [
                        _c("div", { staticClass: "logoiZalet" }, [
                          _c("img", {
                            staticClass: "divZaLogo",
                            attrs: {
                              src: "/content/images/b2b1.png",
                              alt: "B2B logo",
                            },
                          }),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "b-navbar-toggle",
                  {
                    staticClass: "jh-navbar-toggler d-lg-none",
                    attrs: {
                      right: "",
                      href: "javascript:void(0);",
                      "data-toggle": "collapse",
                      target: "nav-collapse",
                      "aria-expanded": "false",
                      "aria-label": "Toggle navigation",
                    },
                  },
                  [
                    _c("font-awesome-icon", {
                      staticClass: "burger",
                      attrs: { icon: "bars" },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-collapse",
                  {
                    staticClass: "mainCollapse",
                    attrs: { id: "nav-collapse", "is-nav": "" },
                  },
                  [
                    _c(
                      "b-navbar-nav",
                      { staticClass: "ml-auto align-items-center" },
                      [
                        _c(
                          "b-nav-item-dropdown",
                          {
                            staticClass: "navbar-menu-item",
                            class: {
                              "is-active-route": _vm.isAdvertisementRoute,
                            },
                            attrs: { right: "", "active-class": "active" },
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "navbar-dropdown-menu",
                                attrs: { slot: "button-content" },
                                slot: "button-content",
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "headerItemi",
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t(
                                          "global.menu.advertisements.main"
                                        )
                                      ),
                                    },
                                  },
                                  [_vm._v("Oglasi")]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.isSuperAdmin ||
                            _vm.isCompanyAdmin ||
                            _vm.isCompanyOrgAdmin ||
                            _vm.isNioAdmin ||
                            _vm.isNioOrgAdmin ||
                            _vm.isNioUser ||
                            _vm.isCompanyAdmin ||
                            _vm.isCompanyOrgAdmin ||
                            _vm.isCompanyUser
                              ? _c(
                                  "b-dropdown-item",
                                  {
                                    attrs: {
                                      to: {
                                        name: "AdvertisementNew",
                                        query: {
                                          mode: "create",
                                          kind: "offer",
                                        },
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.advertisements.advertiseOffer"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("Oglasi ponudu")]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isSuperAdmin ||
                            _vm.isCompanyAdmin ||
                            _vm.isCompanyOrgAdmin ||
                            _vm.isNioAdmin ||
                            _vm.isNioOrgAdmin ||
                            _vm.isNioUser ||
                            _vm.isCompanyAdmin ||
                            _vm.isCompanyOrgAdmin ||
                            _vm.isCompanyUser
                              ? _c(
                                  "b-dropdown-item",
                                  {
                                    attrs: {
                                      to: {
                                        name: "AdvertisementNew",
                                        query: {
                                          mode: "create",
                                          kind: "demand",
                                        },
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.advertisements.advertiseDemand"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("Oglasi potražnju")]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "b-dropdown-item",
                              {
                                attrs: {
                                  to: {
                                    name: "AdvertisementNew",
                                    query: { mode: "browse", kind: "offer" },
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t(
                                          "global.menu.advertisements.findAllOffers"
                                        )
                                      ),
                                    },
                                  },
                                  [_vm._v("Pogledaj sve ponude")]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-dropdown-item",
                              {
                                attrs: {
                                  to: {
                                    name: "AdvertisementNew",
                                    query: { mode: "browse", kind: "demand" },
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t(
                                          "global.menu.advertisements.findAllDemands"
                                        )
                                      ),
                                    },
                                  },
                                  [_vm._v("Pogledaj sve potražnje")]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-nav-item",
                          {
                            staticClass: "navbar-menu-item",
                            staticStyle: { "white-space": "nowrap" },
                            attrs: { to: "/b2b/about", exact: "" },
                          },
                          [
                            _c("span", [
                              _c(
                                "span",
                                {
                                  staticClass: "headerItemi",
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.$t("global.menu.about")
                                    ),
                                  },
                                },
                                [_vm._v("О нама")]
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-nav-item",
                          {
                            staticClass: "navbar-menu-item",
                            staticStyle: { "white-space": "nowrap" },
                            attrs: { to: "/b2b/questions", exact: "" },
                          },
                          [
                            _c("span", [
                              _c(
                                "span",
                                {
                                  staticClass: "headerItemi",
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.$t("global.menu.faq")
                                    ),
                                  },
                                },
                                [_vm._v("Најчешћа питања")]
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-nav-item",
                          {
                            staticClass: "navbar-menu-item",
                            staticStyle: { "white-space": "nowrap" },
                            attrs: { to: "/b2b/news", exact: "" },
                          },
                          [
                            _c("span", [
                              _c(
                                "span",
                                {
                                  staticClass: "headerItemi",
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.$t("global.menu.news")
                                    ),
                                  },
                                },
                                [_vm._v("Најчешћа питања")]
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        (_vm.isAdmin ||
                          _vm.isCMSAdmin ||
                          _vm.isCMSSuperAdmin ||
                          _vm.isSuperAdmin) &&
                        _vm.authenticated
                          ? _c(
                              "b-nav-item-dropdown",
                              {
                                class: {
                                  "router-link-active": _vm.subIsActive(
                                    "/admin"
                                  ),
                                },
                                attrs: {
                                  right: "",
                                  id: "cms-admin-menu",
                                  "active-class": "active",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "boja",
                                    attrs: { slot: "button-content" },
                                    slot: "button-content",
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "cogs" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s("CMS"),
                                        },
                                      },
                                      [_vm._v("CMS")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                (_vm.isAdmin ||
                                  _vm.isCMSSuperAdmin ||
                                  _vm.isSuperAdmin) &&
                                _vm.authenticated
                                  ? _c(
                                      "b-dropdown-item",
                                      {
                                        attrs: {
                                          to: { name: "CMSAdministrators" },
                                          "active-class": "active",
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            domProps: {
                                              textContent: _vm._s(
                                                _vm.$t("global.menu.cms.admins")
                                              ),
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "Upravljanje administratorima"
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  {
                                    attrs: {
                                      to: { name: "CMSUserManagement" },
                                      "active-class": "active",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t("global.menu.cms.users")
                                          ),
                                        },
                                      },
                                      [_vm._v("Upravljanje korisnicima")]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  {
                                    attrs: {
                                      to: { name: "CMSAdvertisements" },
                                      "active-class": "active",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.cms.advertisements"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("Upravljanje oglasima")]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  {
                                    attrs: {
                                      to: { name: "CMSPages" },
                                      "active-class": "active",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t("global.menu.cms.pages")
                                          ),
                                        },
                                      },
                                      [_vm._v("Upravljanje stranicama")]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  {
                                    attrs: {
                                      to: { name: "CMSCodebook" },
                                      "active-class": "active",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t("global.menu.cms.codebooks")
                                          ),
                                        },
                                      },
                                      [_vm._v("Šifarnici")]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  {
                                    attrs: {
                                      to: { name: "CMSNews" },
                                      "active-class": "active",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t("global.menu.cms.news")
                                          ),
                                        },
                                      },
                                      [_vm._v("Vesti")]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  {
                                    attrs: {
                                      to: { name: "CMSReports" },
                                      "active-class": "active",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t("global.menu.cms.reports")
                                          ),
                                        },
                                      },
                                      [_vm._v("Izveštaji")]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isAdmin && _vm.authenticated
                          ? _c(
                              "b-nav-item-dropdown",
                              {
                                attrs: {
                                  right: "",
                                  id: "entity-menu",
                                  "active-class": "active",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "boja",
                                    attrs: { slot: "button-content" },
                                    slot: "button-content",
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "th-list" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t("global.menu.entities.main")
                                          ),
                                        },
                                      },
                                      [_vm._v("Entities")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  { attrs: { to: "/b2b/advertisement" } },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "asterisk" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.entities.advertisement"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("Advertisement")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  { attrs: { to: "/b2b/company" } },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "asterisk" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.entities.company"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("Company")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  { attrs: { to: "/b2b/message" } },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "asterisk" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.entities.message"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("Message")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  { attrs: { to: "/portal-user" } },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "asterisk" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.entities.portalUser"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("PortalUser")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  { attrs: { to: "/portal-user-status" } },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "asterisk" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.entities.portalUserStatus"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("PortalUserStatus")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  { attrs: { to: "/portal-user-role" } },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "asterisk" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.entities.portalUserRole"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("PortalUserRole")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  { attrs: { to: "/b2b/badge" } },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "asterisk" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t("global.menu.entities.badge")
                                          ),
                                        },
                                      },
                                      [_vm._v("Badge")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  {
                                    attrs: {
                                      to: "/b2b/advertisement-supporter",
                                    },
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "asterisk" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.entities.advertisementSupporter"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("AdvertisementSupporter")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  {
                                    attrs: { to: "/b2b/advertisement-status" },
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "asterisk" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.entities.advertisementStatus"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("AdvertisementStatus")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  {
                                    attrs: {
                                      to: "/b2b/advertisement-duration",
                                    },
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "asterisk" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.entities.advertisementDuration"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("AdvertisementDuration")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  { attrs: { to: "/b2b/advertisement-type" } },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "asterisk" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.entities.advertisementType"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("AdvertisementType")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  { attrs: { to: "/b2b/advertisement-kind" } },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "asterisk" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.entities.advertisementKind"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("AdvertisementKind")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  {
                                    attrs: {
                                      to: "/b2b/advertisement-category",
                                    },
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "asterisk" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.entities.advertisementCategory"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("AdvertisementCategory")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  {
                                    attrs: {
                                      to: "/b2b/advertisement-subcategory",
                                    },
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "asterisk" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.entities.advertisementSubcategory"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("AdvertisementSubcategory")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  {
                                    attrs: {
                                      to: "/b2b/advertisement-subsubcategory",
                                    },
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "asterisk" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.entities.advertisementSubsubcategory"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("AdvertisementSubsubcategory")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  { attrs: { to: "/b2b/collaboration" } },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "asterisk" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.entities.collaboration"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("Collaboration")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  {
                                    attrs: { to: "/b2b/collaboration-rating" },
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "asterisk" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.entities.collaborationRating"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("CollaborationRating")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  {
                                    attrs: { to: "/b2b/collaboration-status" },
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "asterisk" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.entities.collaborationStatus"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("CollaborationStatus")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  { attrs: { to: "/b2b/thread" } },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "asterisk" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.entities.thread"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("Thread")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  { attrs: { to: "/b2b/meeting" } },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "asterisk" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.entities.meeting"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("Meeting")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  { attrs: { to: "/b2b/meeting-participant" } },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "asterisk" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.entities.meetingParticipant"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("MeetingParticipant")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  { attrs: { to: "/b2b/meeting-type" } },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "asterisk" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.entities.meetingType"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("MeetingType")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  { attrs: { to: "/b2b/cms-page" } },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "asterisk" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.entities.cmsPage"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("CmsPage")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  { attrs: { to: "/b2b/cms-page-type" } },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "asterisk" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.entities.cmsPageType"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("CmsPageType")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  { attrs: { to: "/b2b/cms-testimonials" } },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "asterisk" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.entities.cmsTestimonials"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("CmsTestimonials")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  { attrs: { to: "/b2b/cms-question" } },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "asterisk" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.entities.cmsQuestion"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("CmsQuestion")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  { attrs: { to: "/b2b/cms-slider" } },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "asterisk" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.entities.cmsSlider"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("CmsSlider")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  { attrs: { to: "/b2b/cms-carousel" } },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "asterisk" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.entities.cmsCarousel"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("CmsCarousel")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  {
                                    attrs: {
                                      to: "/b2b/cms-advertisement-category",
                                    },
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "asterisk" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.entities.cmsAdvertisementCategory"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("CmsAdvertisementCategory")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  { attrs: { to: "/b2b/document" } },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "asterisk" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.entities.document"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("Document")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  { attrs: { to: "/b2b/document-type" } },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "asterisk" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.entities.documentType"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("DocumentType")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  { attrs: { to: "/b2b/document-kind" } },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "asterisk" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.entities.documentKind"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("DocumentKind")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isAdmin && _vm.authenticated
                          ? _c(
                              "b-nav-item-dropdown",
                              {
                                class: {
                                  "router-link-active": _vm.subIsActive(
                                    "/admin"
                                  ),
                                },
                                attrs: {
                                  right: "",
                                  id: "admin-menu",
                                  "active-class": "active",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "boja",
                                    attrs: { slot: "button-content" },
                                    slot: "button-content",
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "cogs" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t("global.menu.admin.main")
                                          ),
                                        },
                                      },
                                      [_vm._v("Administration")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  {
                                    attrs: {
                                      to: "/admin/user-management",
                                      "active-class": "active",
                                    },
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "user" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.admin.userManagement"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("User management")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  {
                                    attrs: {
                                      to: "/admin/jhi-metrics",
                                      "active-class": "active",
                                    },
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "tachometer-alt" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t("global.menu.admin.metrics")
                                          ),
                                        },
                                      },
                                      [_vm._v("Metrics")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  {
                                    attrs: {
                                      to: "/admin/jhi-health",
                                      "active-class": "active",
                                    },
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "heart" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t("global.menu.admin.health")
                                          ),
                                        },
                                      },
                                      [_vm._v("Health")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  {
                                    attrs: {
                                      to: "/admin/jhi-configuration",
                                      "active-class": "active",
                                    },
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "list" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.admin.configuration"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("Configuration")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  {
                                    attrs: {
                                      to: "/admin/audits",
                                      "active-class": "active",
                                    },
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "bell" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t("global.menu.admin.audits")
                                          ),
                                        },
                                      },
                                      [_vm._v("Audits")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  {
                                    attrs: {
                                      to: "/admin/logs",
                                      "active-class": "active",
                                    },
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "tasks" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t("global.menu.admin.logs")
                                          ),
                                        },
                                      },
                                      [_vm._v("Logs")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.swaggerEnabled
                                  ? _c(
                                      "b-dropdown-item",
                                      {
                                        attrs: {
                                          to: "/admin/docs",
                                          "active-class": "active",
                                        },
                                      },
                                      [
                                        _c("font-awesome-icon", {
                                          attrs: { icon: "book" },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            domProps: {
                                              textContent: _vm._s(
                                                _vm.$t(
                                                  "global.menu.admin.apidocs"
                                                )
                                              ),
                                            },
                                          },
                                          [_vm._v("API")]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "b-nav-item",
                          {
                            staticClass: "navbar-menu-item",
                            staticStyle: { "white-space": "nowrap" },
                            attrs: { to: "/", exact: "" },
                          },
                          [
                            _c("span", [
                              _c(
                                "span",
                                {
                                  staticClass: "headerItemi",
                                  staticStyle: { color: "#253B6F !important" },
                                },
                                [_vm._v("S2B")]
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.languages && Object.keys(_vm.languages).length > 1
                          ? _c(
                              "b-nav-item-dropdown",
                              { attrs: { right: "", id: "language-menu" } },
                              [
                                _c(
                                  "span",
                                  {
                                    attrs: { slot: "button-content" },
                                    slot: "button-content",
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      staticClass: "ikonica",
                                      staticStyle: { color: "white" },
                                      attrs: { icon: "globe" },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm._l(_vm.languages, function (value, key) {
                                  return _c(
                                    "b-dropdown-item",
                                    {
                                      key: "lang-" + key,
                                      class: {
                                        active: _vm.isActiveLanguage(key),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.changeLanguage(key)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(value.name) +
                                          "\n                            "
                                      ),
                                    ]
                                  )
                                }),
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "b-nav-item-dropdown",
                          {
                            staticClass: "boja profileMenu",
                            class: {
                              "router-link-active": _vm.subIsActive("/account"),
                            },
                            attrs: {
                              right: "",
                              href: "javascript:void(0);",
                              id: "account-menu",
                              "active-class": "active",
                            },
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "mojProfil",
                                attrs: { slot: "button-content" },
                                slot: "button-content",
                              },
                              [
                                !_vm.authenticated
                                  ? _c("font-awesome-icon", {
                                      staticClass: "ikonica",
                                      staticStyle: { color: "white" },
                                      attrs: { icon: "user" },
                                    })
                                  : _c("span", [
                                      _vm._v(_vm._s(_vm.getUserInitials())),
                                    ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.authenticated &&
                            _vm.portalUser &&
                            _vm.portalUser.company
                              ? _c(
                                  "b-dropdown-item",
                                  {
                                    attrs: {
                                      to: {
                                        name: "CompanyView",
                                        params: {
                                          companyId: _vm.portalUser.company.id,
                                        },
                                      },
                                      tag: "b-dropdown-item",
                                      "active-class": "active",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.account.accountData"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("Moji podaci")]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.authenticated &&
                            _vm.portalUser &&
                            _vm.portalUser.userOrganization &&
                            !_vm.portalUser.company &&
                            (_vm.isNioAdmin ||
                              _vm.isNioOrgAdmin ||
                              _vm.isNioSuperAdmin)
                              ? _c(
                                  "b-dropdown-item",
                                  {
                                    attrs: {
                                      to: {
                                        name: "PortalUserOrganizationEdit",
                                        params: {
                                          portalUserOrganizationId:
                                            _vm.portalUser.userOrganization.id,
                                        },
                                      },
                                      tag: "b-dropdown-item",
                                      "active-class": "active",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.account.accountData"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("Moji podaci")]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.authenticated
                              ? _c(
                                  "b-dropdown-item",
                                  {
                                    attrs: {
                                      to: "/b2b/account/settings",
                                      tag: "b-dropdown-item",
                                      "active-class": "active",
                                    },
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "wrench" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.account.settings"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("Settings")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.authenticated &&
                            (_vm.isNioAdmin ||
                              _vm.isNioOrgAdmin ||
                              _vm.isNioUser ||
                              _vm.isCompanyAdmin ||
                              _vm.isCompanyOrgAdmin ||
                              _vm.isSuperAdmin)
                              ? _c("b-dropdown-divider")
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isNioAdmin ||
                            _vm.isNioOrgAdmin ||
                            _vm.isNioUser ||
                            _vm.isCompanyAdmin ||
                            _vm.isCompanyOrgAdmin ||
                            _vm.isSuperAdmin
                              ? _c(
                                  "b-dropdown-item",
                                  {
                                    attrs: {
                                      to: {
                                        name: "AdvertisementNew",
                                        query: {
                                          mode: "create",
                                          kind: "offer",
                                        },
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.advertisements.advertiseOffer"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("Oglasi ponudu")]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isNioAdmin ||
                            _vm.isNioOrgAdmin ||
                            _vm.isNioUser ||
                            _vm.isCompanyAdmin ||
                            _vm.isCompanyOrgAdmin ||
                            _vm.isSuperAdmin
                              ? _c(
                                  "b-dropdown-item",
                                  {
                                    attrs: {
                                      to: {
                                        name: "AdvertisementNew",
                                        query: {
                                          mode: "create",
                                          kind: "demand",
                                        },
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.advertisements.advertiseDemand"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("Oglasi potražnju")]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.authenticated &&
                            _vm.hasB2BRole &&
                            _vm.portalUser &&
                            _vm.portalUser.company
                              ? _c("b-dropdown-divider")
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.authenticated &&
                            _vm.hasB2BRole &&
                            _vm.portalUser &&
                            _vm.portalUser.company
                              ? _c("b-dropdown-header", [_vm._v("B2B")])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.authenticated &&
                            _vm.hasB2BAdminRole &&
                            _vm.portalUser &&
                            _vm.portalUser.company
                              ? _c(
                                  "b-dropdown-item",
                                  {
                                    attrs: {
                                      to: {
                                        name: "CompanyAdvertisementsManage",
                                        params: {
                                          companyId: _vm.portalUser.company.id,
                                        },
                                      },
                                      tag: "b-dropdown-item",
                                      "active-class": "active",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.account.advertisements"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("Moji oglasi")]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.authenticated &&
                            _vm.hasB2BAdminRole &&
                            _vm.portalUser &&
                            _vm.portalUser.company
                              ? _c(
                                  "b-dropdown-item",
                                  {
                                    attrs: {
                                      to: {
                                        name: "CompanyCollaborations",
                                        params: {
                                          companyId: _vm.portalUser.company.id,
                                        },
                                      },
                                      tag: "b-dropdown-item",
                                      "active-class": "active",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.account.collaborations"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("Moje saradnje")]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.authenticated &&
                            _vm.hasB2BAdminRole &&
                            _vm.portalUser &&
                            _vm.portalUser.company
                              ? _c(
                                  "b-dropdown-item",
                                  {
                                    attrs: {
                                      to: {
                                        name: "CompanyThreads",
                                        params: {
                                          companyId: _vm.portalUser.company.id,
                                        },
                                      },
                                      tag: "b-dropdown-item",
                                      "active-class": "active",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.account.messages"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("Moje poruke")]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.authenticated &&
                            _vm.hasB2BAdminRole &&
                            _vm.portalUser &&
                            _vm.portalUser.company
                              ? _c(
                                  "b-dropdown-item",
                                  {
                                    attrs: {
                                      to: {
                                        name: "CompanyCalendar",
                                        params: {
                                          companyId: _vm.portalUser.company.id,
                                        },
                                      },
                                      tag: "b-dropdown-item",
                                      "active-class": "active",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.account.calendar"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("Kalendar")]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.authenticated &&
                            (_vm.isSuperAdmin || _vm.isCompanyAdmin)
                              ? _c("b-dropdown-divider")
                              : _vm._e(),
                            _vm._v(" "),
                            (_vm.isCompanyAdmin || _vm.isCompanySuperAdmin) &&
                            _vm.authenticated &&
                            _vm.portalUser &&
                            _vm.portalUser.company
                              ? _c(
                                  "b-dropdown-item",
                                  {
                                    attrs: {
                                      to: {
                                        name: "CompanyPortalUsers",
                                        params: {
                                          companyId: _vm.portalUser.company.id,
                                        },
                                      },
                                      tag: "b-dropdown-item",
                                      "active-class": "active",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.account.additionalusers"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("Unos dodatnih korisnika")]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.authenticated &&
                            (_vm.isCompanyAdmin || _vm.isSuperAdmin) &&
                            _vm.portalUser &&
                            _vm.portalUser.company
                              ? _c(
                                  "b-dropdown-item",
                                  {
                                    attrs: {
                                      to: {
                                        name: "CompanyOrganization",
                                        params: {
                                          companyId: _vm.portalUser.company.id,
                                        },
                                      },
                                      tag: "b-dropdown-item",
                                      "active-class": "active",
                                    },
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "sitemap" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.account.organizationalUnits"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("Organizacione jedinice")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.authenticated &&
                            (_vm.isSuperAdmin || _vm.isNioAdmin)
                              ? _c(
                                  "b-dropdown-item",
                                  {
                                    attrs: {
                                      to: "/ri-research-organization-unit",
                                      tag: "b-dropdown-item",
                                      "active-class": "active",
                                    },
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "sitemap" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.account.nioOrganizations"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("Organizacione jedinice")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.authenticated &&
                            _vm.isSuperAdmin &&
                            (!_vm.portalUser || !_vm.portalUser.company)
                              ? _c(
                                  "b-dropdown-item",
                                  {
                                    attrs: {
                                      to: { name: "CompanyOrganizationCreate" },
                                      tag: "b-dropdown-item",
                                      "active-class": "active",
                                    },
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "sitemap" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.account.organizationalUnits"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("Organizacione jedinice")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.authenticated && _vm.isSuperAdmin
                              ? _c(
                                  "b-dropdown-item",
                                  {
                                    attrs: {
                                      to: "/admin/invite-nio-admin",
                                      tag: "b-dropdown-item",
                                      "active-class": "active",
                                    },
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "user-plus" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.account.inviteAdmin"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("Pozovi NIO administratora")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.authenticated &&
                            _vm.portalUser &&
                            _vm.portalUser.userOrganization &&
                            _vm.portalUser.userOrganization.nioInstitution &&
                            _vm.isNioSuperAdmin
                              ? _c(
                                  "b-dropdown-item",
                                  {
                                    attrs: {
                                      to: {
                                        name: "NioPortalUsers",
                                        params: {
                                          nioId:
                                            _vm.portalUser.userOrganization
                                              .nioInstitution.id,
                                        },
                                      },
                                      tag: "b-dropdown-item",
                                      "active-class": "active",
                                    },
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "users" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.account.nioUsers"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("NIO korisnici")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.authenticated &&
                            (_vm.isNioAdmin ||
                              _vm.isCompanyAdmin ||
                              _vm.isNioOrgAdmin ||
                              _vm.isCompanyOrgAdmin ||
                              _vm.isNioUser ||
                              _vm.isCompanyUser)
                              ? _c("b-dropdown-divider")
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.authenticated &&
                            (_vm.isNioAdmin ||
                              _vm.isCompanyAdmin ||
                              _vm.isNioOrgAdmin ||
                              _vm.isCompanyOrgAdmin ||
                              _vm.isNioUser ||
                              _vm.isCompanyUser)
                              ? _c("b-dropdown-header", [_vm._v("S2B")])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.authenticated &&
                            (_vm.isNioAdmin ||
                              _vm.isCompanyAdmin ||
                              _vm.isNioOrgAdmin ||
                              _vm.isCompanyOrgAdmin ||
                              _vm.isNioUser ||
                              _vm.isCompanyUser)
                              ? _c(
                                  "b-dropdown-item",
                                  {
                                    attrs: {
                                      to: "/organization-preview",
                                      tag: "b-dropdown-item",
                                      "active-class": "active",
                                    },
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "eye" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.account.organizationPreview"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("Pregled organizacije")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.authenticated &&
                            (_vm.isNioAdmin ||
                              _vm.isCompanyAdmin ||
                              _vm.isNioOrgAdmin ||
                              _vm.isCompanyOrgAdmin)
                              ? _c(
                                  "b-dropdown-item",
                                  {
                                    attrs: {
                                      to: "/requests-preview",
                                      tag: "b-dropdown-item",
                                      "active-class": "active",
                                    },
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "list-alt" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.account.requestsPreview"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("Zahtevi")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.authenticated
                              ? _c("b-dropdown-divider")
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.authenticated
                              ? _c(
                                  "b-dropdown-item",
                                  {
                                    attrs: {
                                      id: "logout",
                                      "active-class": "active",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.logout()
                                      },
                                    },
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "sign-out-alt" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t("global.menu.account.logout")
                                          ),
                                        },
                                      },
                                      [_vm._v("Sign out")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.authenticated
                              ? _c(
                                  "b-dropdown-item",
                                  {
                                    attrs: {
                                      id: "login",
                                      "active-class": "active",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openLogin()
                                      },
                                    },
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "sign-in-alt" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t("global.menu.account.login")
                                          ),
                                        },
                                      },
                                      [_vm._v("Sign in")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.authenticated
                              ? _c(
                                  "b-dropdown-item",
                                  {
                                    attrs: {
                                      to: "/b2b/register-info",
                                      tag: "b-dropdown-item",
                                      id: "register",
                                      "active-class": "active",
                                    },
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "user-plus" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.menu.account.register"
                                            )
                                          ),
                                        },
                                      },
                                      [_vm._v("Register")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _vm.isHomepage || _vm.isAdvPage
          ? _c(
              "b-navbar-nav",
              {
                staticClass:
                  "prviNav all d-flex justify-content-center align-items-center",
              },
              [
                _c("div", { staticClass: "container" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      {
                        class: {
                          "col-sm-7 col-md-7": _vm.isHomepage,
                          "col-12": !_vm.isHomepage,
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "selInp" },
                          [
                            _c(
                              "b-input-group",
                              { staticStyle: { height: "max-content" } },
                              [
                                _c("b-form-input", {
                                  ref: "searchadv",
                                  staticClass: "orange-form",
                                  attrs: {
                                    id: "searchadv",
                                    name: "searchadv",
                                    type: "text",
                                    placeholder: _vm.$t(
                                      "global.menu.searchAdB2B"
                                    ),
                                  },
                                  on: {
                                    keyup: [
                                      function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        return _vm.searchAdvSub()
                                      },
                                      function ($event) {
                                        return _vm.autoAdvSub()
                                      },
                                    ],
                                    click: function ($event) {
                                      return _vm.autoAdvSub()
                                    },
                                  },
                                  model: {
                                    value: _vm.txtsearchNav,
                                    callback: function ($$v) {
                                      _vm.txtsearchNav = $$v
                                    },
                                    expression: "txtsearchNav",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "input-group-append" },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        staticClass: "orange-form",
                                        on: {
                                          click: function ($event) {
                                            return _vm.searchAdvSub()
                                          },
                                        },
                                      },
                                      [
                                        _c("font-awesome-icon", {
                                          attrs: {
                                            icon: "search",
                                            scale: "1.3",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.isHomepage
                      ? _c(
                          "div",
                          {
                            staticClass: "col-sm-5 col-md-5",
                            staticStyle: { "max-width": "100%" },
                          },
                          [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.mainSearchCategory,
                                    expression: "mainSearchCategory",
                                  },
                                ],
                                staticClass: "form-control orange-form",
                                attrs: { id: "kat", name: "kat" },
                                on: {
                                  click: function ($event) {},
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function (
                                        o
                                      ) {
                                        return o.selected
                                      })
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.mainSearchCategory = $event.target
                                      .multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                },
                              },
                              _vm._l(_vm.advCategList, function (element) {
                                return _c(
                                  "option",
                                  {
                                    key: element.id,
                                    domProps: { value: element.id },
                                  },
                                  [
                                    _vm.$store.getters.currentLanguage === "sr"
                                      ? _c("span", { staticClass: "ml-2" }, [
                                          _vm._v(_vm._s(element.name)),
                                        ])
                                      : _vm.$store.getters.currentLanguage ===
                                        "src"
                                      ? _c("span", { staticClass: "ml-2" }, [
                                          _vm._v(_vm._s(element.nameSrc)),
                                        ])
                                      : _vm.$store.getters.currentLanguage ===
                                        "en"
                                      ? _c("span", { staticClass: "ml-2" }, [
                                          _vm._v(_vm._s(element.nameEn)),
                                        ])
                                      : _vm._e(),
                                  ]
                                )
                              }),
                              0
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm._m(0),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _vm._v("\n                 \n            "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }